// extracted by mini-css-extract-plugin
export default {"timeline-container":"Work_timeline-container__-e3n2"};